export const KLAVIYO_EVENTS = [
  'acct/system/resubscribe',
  'acct/system/resume_subscription',
  'acct/system/updated_payment_method',
  'acct/system/upgrade_subscription',
  'acct/system/verify_email_fail',
  'acct/user/clicked_full_refund',
  'acct/user/clicked_pause',
  'acct/user/clicked_resubscribe',
  'acct/user/clicked_resume',
  'acct/user/clicked_upgrade',
  'acct/user/clicked_upgrading_plan',
  'boughtPlagCheckCredits',
  'boughtPremium',
  'chrome-active/user/installed_extension',
  'chrome-active/user/uninstalled-chrome-ext',
  'clickedBecomeAnAffiliateButton',
  'clickedExtensionLink',
  'copiedArticle',
  'ctgr/user/clicked_add_citation',
  'ctgr/user/clicked_copy_all_full_text_citations_button',
  'faqOpened',
  'grmr/system/grammar_check_completed',
  'grmr/user/clicked_correct_all_button',
  'grmr/user/clicked_paraphrase_button',
  'grmr/user/input_limit_exceeded',
  'grmr/user/pasted_text',
  'loginSuccess',
  'maxedChars',
  'openedCheckout',
  'openedMainMenu',
  'pauseFeedback',
  'paymentError',
  'plag/system/rechage_failed',
  'plag/system/recharge_successful',
  'plag/user/cancelled_after_price_check',
  'plag/user/changed_credit_plan',
  'plag/user/clicked_buy_more_credits_button',
  'plag/user/clicked_scan_button',
  'plag/user/closed_buy_more_credit_modal',
  'plag/user/submittedCard',
  'plag/user/viewed_report',
  'pphr/user/changed_wf_value',
  'pphr/user/clicked_next_quill_sentence',
  'pphr/user/clicked_prev_quill_sentence',
  'pphr/user/pressed_hotkey',
  'premiumLinkClicked',
  'rateLimitReached',
  'requillArticle',
  'rshr/user/clicked_correct_error',
  'rshr/user/created_new_project',
  'rshr/user/searched_query',
  'rshr/user/triggered_autocompleter',
  'rshr/user/voice_transcript',
  'selectPlan',
  'settingChanged',
  'shownPersonalizeQuestions',
  'shownWelcomeAfterRegistration',
  'sideDrawerStateChanged',
  'signupSuccess',
  'skippedPersonalizeSection',
  'smzr/system/started_summarization',
  'smzr/user/changed_mode',
  'smzr/user/char_limit_exceeded',
  'smzr/user/clicked_copy_all',
  'smzr/user/clicked_delete_text',
  'smzr/user/clicked_paraphrase_summary',
  'submittedCard',
  'submittedFeedback',
  'submittedInput',
  'submittedSentence',
  'thesaurused',
  'togglePriority',
  'unsubscribeFeedback',
  'unverifiedSelectPlan',
  'upgradeLinkClicked',
  'userClickedOnUnsubscribePremiumButton',
  'visitPremium',
  'visitedAffiliatePage',
  'visitedCareersPage',
  'visitedContactUsPage',
  'visitedForgotPasswordPage',
  'visitedLoginPage',
  'visitedParaphraser',
  'visitedPrivacyPolicy',
  'visitedSignupPage',
  'visitedSummarizer',
  'visitedTeamPage',
  'visitedTermsOfService',
  'visitedUpgradePage',
  'visitedUserAccountsPage',
  'visitedWordInstallationHelpPage',
];
